import { createAppKit } from '@reown/appkit/react'
import { WagmiProvider } from 'wagmi'
import { mainnet, bsc, polygon, arbitrum, base } from '@reown/appkit/networks'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

// Setup QueryClient
const queryClient = new QueryClient()

// 🚨 PENTING: GANTI TEKS DI BAWAH INI DENGAN PROJECT ID DARI CLOUD.REOWN.COM 🚨
const projectId = '7c1709b1d75898037053af448d5eb488' 

// Daftar jaringan yang didukung
const networks = [mainnet, bsc, polygon, arbitrum, base]

// Setup Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({ networks, projectId, ssr: true })

// Inisialisasi Reown AppKit (Modal Connect Wallet)
createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata: {
    name: 'Power Protocol Presale',
    description: 'Power Protocol Presale and Airdrop',
    url: 'https://powerprotocol.com', 
    icons: ['https://avatars.githubusercontent.com/u/37784886']
  },
  
  // 🚀 MEMATIKAN LOGIN EMAIL & SOCIAL MEDIA (HANYA WALLET)
  features: {
    email: false,
    socials: false,
  },

  // SETTING DARK MODE YANG BENAR
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#a855f7', // Warna tombol & loading utama (Ungu Power Protocol)
    '--w3m-border-radius-master': '16px' // Membulatkan ujung modal agar tidak kaku
  },

  // SETTING URUTAN WALLET DEFAULT
  featuredWalletIds: [
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust Wallet
    '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662', // Bitget Wallet
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709', // OKX Wallet
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa', // Coinbase Wallet
    '0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150', // SafePal
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4'  // Binance Web3 Wallet
  ]
})

// Provider Utama yang akan membungkus Aplikasi
export function Web3Provider({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  )
}